/* ModalNotifications.js */
/* @author: anghello */

import React, { useCallback, useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Strings from '../../../translations/Translations';
import PSO from '../../../services/PSO';
import './modal_notifications.scss';
import { IoNotificationsOutline } from "react-icons/io5";
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { Alert } from 'bootstrap';

export default function ModalNotifications({ authenticated, open, setOpen }) {
  const toggle = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  const history = useHistory();
  const [notifications, setNotifications] = useState();

  const getNotifications = useCallback(async () => {
    try {
      const args = { un: authenticated.un, al: authenticated.al };
      const response = await PSO.getNews(args);
      if (response && response.result === 'success') {
        if (response.its && response.its.length) {
          setNotifications(response.its);
        } else {
          setNotifications(null);
        }
      } else {
        toast.error(`${Strings('error_on_gettting_notifications')} [RESP]`);
      }
    } catch (err) {
      console.error(err);
      toast.error(`${Strings('error_on_gettting_notifications')} [REQ]`);
    }
  }, [authenticated]);

  useEffect(() => {
    getNotifications();
  }, [getNotifications]);

  return (
    <Modal isOpen={open} toggle={toggle} size='md'>
      <ModalHeader toggle={toggle}>
        {Strings('notifications')}
      </ModalHeader>
      <ModalBody className='modal_notifications_body'>
        {notifications && notifications.length && (
          <div className='row'>
            {notifications.map((item) => (
              <div
                key={item.id}
                className='col-12 d-flex align-items-center not-row'
                onClick={() => {
                  history.push(`/edit/${item.po}`);
                  toggle();
                }}
              >
                <div className='icon-flex'>
                  <IoNotificationsOutline size={25} />
                </div>
                <div className='text-flex'>
                  <p className='headline'>{item.ti}</p>
                  <p className='subline'>{item.aun}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {notifications === null && (
          <div className='mt-2'>
            <Alert>
              {Strings('you_have_no_notifications_at_the_moment')}
            </Alert>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}